import { dropElements } from '../js/utils';

/**
 * @description 蓝牙命令日志返回辅助管理程序
 * 注意: 如果处理程序中需要用到该实例, 则use的参数不能是箭头函数
 * @export
 * @class CmdLogManager
 */
export default class CmdLogManager {
  constructor() {
    this.log = '';
    this.chain = [];
    this.index = -1;
  }

  use(fn) {
    this.chain.push(fn);
  }

  delete(fn) {
    this.chain = dropElements(this.chain, (item) => {
      return item === fn;
    });
  }

  next() {
    this.index++;
    if (this.chain[this.index]) {
      this.chain[this.index].call(this, this.log, this.next.bind(this));
    } else {
      // eslint-disable-next-line no-unused-expressions
      typeof this.cb === 'function' && this.cb();
    }
  }

  // TODO 需要挂起执行队列
  execute(log, cb) {
    this.index = -1;
    this.log = log;
    this.next();
    this.cb = cb;
  }
}
